import { Controller } from 'stimulus'

const FADE_MS = 300

export default class extends Controller {
  connect() {
    this.element.scrollIntoView({ block: 'nearest' })

    this.onBeforeStreamRender = this.onBeforeStreamRender.bind(this)
    document.addEventListener('turbo:before-stream-render', this.onBeforeStreamRender)
  }

  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.onBeforeStreamRender)
  }

  cancel(event) {
    event.preventDefault()
    event.stopPropagation()

    const href = event.currentTarget.href

    this.fadeOut().then(() => {
      fetch(href, {
        headers: {
          Accept: 'text/vnd.turbo-stream.html'
        },
        credentials: 'same-origin'
      })
        .then((response) => response.text())
        .then((html) => window.Turbo.renderStreamMessage(html))
    })
  }

  onBeforeStreamRender(event) {
    const originalRender = event.detail.render

    event.detail.render = async (streamElement) => {
      if (!this.shouldFadeOutForStream(streamElement)) {
        await originalRender(streamElement)
        return
      }

      await this.fadeOut()
      await originalRender(streamElement)
    }
  }

  shouldFadeOutForStream(streamElement) {
    const targetId = streamElement.getAttribute('target')
    if (targetId !== this.element.id) return false
    if (!['replace', 'remove', 'update'].includes(streamElement.action)) return false

    // Validation errors re-render the form — skip exit animation.
    if (streamElement.action === 'replace' || streamElement.action === 'update') {
      const root = streamElement.templateContent?.firstElementChild
      if (root?.classList?.contains('community-links-form')) return false
    }

    return true
  }

  fadeOut() {
    return new Promise((resolve) => {
      if (this.element.classList.contains('is-fading-out')) {
        resolve()
        return
      }

      let resolved = false
      const done = () => {
        if (resolved) return
        resolved = true
        resolve()
      }

      this.element.classList.remove('is-fading-in')
      this.element.classList.add('is-fading-out')
      this.element.addEventListener('animationend', () => {
        this.element.style.opacity = '0'
        done()
      }, { once: true })
      window.setTimeout(() => {
        this.element.style.opacity = '0'
        done()
      }, FADE_MS + 50)
    })
  }
}
